import { Ioption } from 'tradevan-ui/type';
import { EnumDownloadType, EnumExportItemList } from 'view/Layout/enum';
import { IexportItemList } from 'view/Layout/type';

/** 驗收單下載 報表下載下拉選單 */
export const getRevQueryDownloadOption = (
  exportItemList: IexportItemList,
): Ioption[] => {
  const temp = [
    {
      value: EnumDownloadType.報表下載,
      label: '報表下載',
      show: exportItemList[EnumExportItemList.rptDefault],
    },
    {
      value: EnumDownloadType.批次預覽,
      label: '批次預覽',
      show: exportItemList[EnumExportItemList.previewDefault],
    },
    {
      value: EnumDownloadType.TXT檔下載,
      label: 'TXT檔下載',
      show: exportItemList[EnumExportItemList.flatfileTxt],
    },
    {
      value: EnumDownloadType.CSV檔下載,
      label: 'CSV檔案下載',
      show: exportItemList[EnumExportItemList.flatfileCsv],
    },
  ];

  return temp.filter((v) => v.show);
};

export default getRevQueryDownloadOption;
